import { render } from "./Orientacoes.vue?vue&type=template&id=6404d204"
import script from "./Orientacoes.vue?vue&type=script&lang=js"
export * from "./Orientacoes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__